import { Avatar } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import { JupiterTheme } from '../theme/types';

const DEFAULT_SIZE = '30px';
const DEFAULT_FONT_SIZE = '18px';
const styles = (theme: JupiterTheme) => {
  const avatar = {
    borderRadius: '50%',
  };
  return createStyles({
    avatar,
    avatarLetter: {
      ...avatar,
      backgroundColor: theme.palette.primary.main,
      textTransform: 'uppercase',
    },
    alignLetter: {
      height: '1rem',
      lineHeight: '.95rem',
    },
    empty: {
      opacity: 0.5,
    },
  });
};

interface Props extends WithStyles<typeof styles> {
  name: string;
  size?: string;
  fontSize?: string;
}

class UserAvatar extends Component<Props> {
  static defaultProps = {
    size: DEFAULT_SIZE,
    fontSize: DEFAULT_FONT_SIZE,
  };

  render() {
    const { classes, name, size, fontSize } = this.props;
    // TODO: Load user profile image if exists
    return name ? (
      <Avatar
        className={classes.avatarLetter}
        style={{ width: size, height: size, fontSize: fontSize }}
      >
        <span className={classes.alignLetter}>{name.charAt(0)}</span>
      </Avatar>
    ) : (
      <Avatar
        className={classes.avatar}
        classes={{
          colorDefault: classes.empty,
        }}
        style={{ width: size, height: size, fontSize: fontSize }}
      />
    );
  }
}

export default withStyles(styles)(UserAvatar);
